'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _TotalHeader = require('./TotalHeader.jsx');

var _TotalHeader2 = _interopRequireDefault(_TotalHeader);

var _TotalDetails = require('./TotalDetails.jsx');

var _TotalDetails2 = _interopRequireDefault(_TotalDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Total(props) {
  var components = props.components,
      optionPrice = props.optionPrice;


  var stylePriceContainer = {
    backgroundColor: components.PriceContainer.backgroundColor
  };

  /* Is the segment a split ticketing segment or not: how to find out? */
  /* Look at the difference in the JSON between a split segment and a non split */

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Total' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, stylePriceContainer, { padding: '10px' }) },
          _react2.default.createElement(_TotalHeader2.default, null)
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, stylePriceContainer, { padding: '10px' }) },
          _react2.default.createElement(_TotalDetails2.default, {
            perPassenger: optionPrice.priceItemList,
            total: optionPrice.totalPriceItem
          })
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Total);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Total.jsx
// module id = 1485
// module chunks = 0